import React, { useState, useRef, useEffect } from 'react';
import {
  Grid,
  Typography,
  makeStyles,
  Theme,
  createStyles,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@material-ui/core';
import {
  mdiPhone,
  mdiBook,
  mdiCar,
  mdiParking,
  mdiPackageVariantClosed,
  mdiChevronDown,
  mdiMotorbike,
  mdiPageFirst,
  mdiFileOutline,
  mdiBarcode,
} from '@mdi/js';
import Icon from '@mdi/react';

import jMoment from 'moment-jalaali';
import { translate } from '../../../utils/helpers';
import { useQueryClient, useMutation } from 'react-query';
import updateEntranceStatus from '../requests/updateEntranceStatus';

//Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pelakMotor: {
      padding: '5px 5px 5px 0',
      border: '1px solid #BDBDBD',
      borderRadius: '2px',
    },
    infoIcon: {
      color: 'inherit',
    },
    infoSection: {
      color: '#2f4858',
      padding: '8px',
    },
    infoBar: {
      flexShrink: 1,
      display: 'inline',
    },
    namePlateText: {
      paddingLeft: '8px',
      fontSize: '18px',
    },
    namePlateNumber: {
      paddingLeft: '8px',
      fontSize: '14px',
    },
    namePlate: {
      flexShrink: 1,
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '8px',
    },
    parentGrid: {
      minWidth: '100%',
      backgroundColor: 'white',
      padding: '0px',
      marginTop: '12px',
    },
    idBar: {
      display: 'flex',
      padding: '10px',
    },
    profileImage: {
      maxWidth: '48px',
      maxHeight: '48px',
      borderRadius: '50%',
    },
    root: {
      marginTop: '30px',
    },

    driverMobView: {
      paddingLeft: '0px',
    },
    tabs: {
      zIndex: 12,
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.08)',
      position: 'fixed',
      top: '56px',
      right: '0',
      borderBottom: '1',
      borderColor: '#000',
      width: '100%',
      backgroundColor: '#fff',
    },
    pelak: {
      padding: '5px 5px 5px 0',
      border: '1px solid #BDBDBD',
      borderRadius: '2px',
      marginLeft: '20px',
    },
    status: {
      padding: '0 10px',
    },
    LOADED: {
      border: '1px solid #12B42B',
      borderRadius: '4px',
      backgroundColor: '#E8FAEB',
      color: '#12B42B',
      padding: '12px',
      margin: '12px 0 16px',
    },
    EXITED: {
      border: '1px solid #252525',
      borderRadius: '4px',
      backgroundColor: '#ededed',
      color: '#252525',
      padding: '12px',
      margin: '12px 0 16px',
    },
    ENTERED: {
      border: '1px solid #0085FF',
      borderRadius: '4px',
      backgroundColor: '#E8F3FA',
      color: '#0085FF',
      padding: '12px',
      margin: '12px 0 16px',
    },
    WAITING: {
      border: '1px solid #FFB800',
      borderRadius: '4px',
      backgroundColor: '#fffef2',
      color: '#FFB800',
      padding: '12px',
      margin: '12px 0 16px',
    },
  })
);


export const DriverCard = (props: any) => {
  const [entranceStatusCode, setEntranceStatusCode] = useState('');
  const [expandedState, setExpandedState] = useState<boolean>(false);
  const [cardExpanded, setCardExpanded] = useState<boolean>(false);

  const accordionEl = useRef(null);
  const cardEl = useRef(null);

  const classes = useStyles();

  const vehicle = props.vehicle;

  const queryClient = useQueryClient();

  useEffect(() => {
    setEntranceStatusCode(vehicle.status);
  })

  //BUG
  const statusUpdate = useMutation(updateEntranceStatus, {
    onSuccess: async () => {
      await queryClient.invalidateQueries('vehicles');
      //toast
      const state = queryClient.getQueryState('vehicles');
    },
  });

  const handleStatusRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const updatedValue = (event.target as HTMLInputElement).value;
    setEntranceStatusCode(updatedValue);
    setExpandedState(!expandedState);
    const newStatusForEntrance = {
      description: `Changing status of entrance id ${vehicle.id}`,
      ids: [vehicle.id],
      status: updatedValue,
    };
    statusUpdate.mutate(newStatusForEntrance);
  }


  return (
    <React.Fragment>
        <Accordion expanded={cardExpanded} ref={cardEl} style={{ marginBottom: "16px" }}>
          <AccordionSummary
            onClick={() => setCardExpanded(!cardExpanded)}
            style={{ padding: 0 }}
          >
            <Grid item xs={12} spacing={1} className={classes.idBar}>
              <Grid item xs={3} className={classes.namePlate}>
                <Typography variant="body1" className={classes.namePlateText} style={{ textAlign: "right" }}>
                  {vehicle.driverName}
                </Typography>
              </Grid>
              <Grid item xs={6} className={classes.namePlate}>
                <Typography variant="body1" className={classes.namePlateText}>
                  {vehicle.vehicleType !== 'موتورسیکلت' ? (
                    <Grid item container xs={10} spacing={1} className={classes.infoBar}>
                      <span className={classes.pelak}>
                        <span style={{ borderLeft: '1px solid #BDBDBD', padding: '5px' }}>
                          {vehicle.vehiclePlateNumber.substring(7)}
                        </span>{' '}
                        {vehicle.vehiclePlateNumber.substring(3, 6)}{' '}
                        {vehicle.vehiclePlateNumber.substring(2, 3)}{' '}
                        {vehicle.vehiclePlateNumber.substring(0, 2)}
                      </span>
                    </Grid>
                  ) : (
                    <Grid item xs={10} spacing={1} className={classes.infoBar}>
                      {/* <span>{vehicle.vehicleType}</span> */}
                      <span className={classes.pelakMotor}>
                        {/* {vehicle.vehiclePlateNumber.substring(3, 6)}{' '} */}
                        {vehicle.vehiclePlateNumber.substring(3, 7)}{'\n'}
                        {vehicle.vehiclePlateNumber.substring(0, 3)}
                      </span>
                    </Grid>
                  )
                  }
                </Typography>
              </Grid>
              <Grid item xs={3} className={classes.namePlate} style={{ textAlign: "center" }}>
                <Typography variant="body1" className={classes.namePlateText}>
                  {vehicle.vehicleType}
                </Typography>
              </Grid>
            </Grid>
          </AccordionSummary>
          <Divider />
          <AccordionDetails style={{ display: "block" }}>
            <Grid container className={classes.status}>
              <Grid item xs={12} spacing={1}>
                <Accordion expanded={expandedState} ref={accordionEl} className={classes[vehicle.status]}>
                  <AccordionSummary
                    onClick={() => setExpandedState(!expandedState)}
                    expandIcon={<Icon path={mdiChevronDown} size={1} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography variant="body2">
                      {translate((vehicle.type == "PARCEL" ? "p" : "") + vehicle.status, 'driver')}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid
                      container
                      direction="column"
                      justifyContent="flex-start"
                      alignItems="stretch"
                    >
                      <RadioGroup
                        row
                        name="entranceStatusCode"
                        value={entranceStatusCode}
                        onChange={handleStatusRadioChange}
                        defaultValue={vehicle.status}
                      >
                        <Grid item xs={12} className={classes.LOADED}>
                          <FormControlLabel
                            value="LOADED"
                            control={<Radio />}
                            label={vehicle.type == "PARCEL" ? "اتمام تخلیه" : "بارگیری شده"}
                          />
                        </Grid>
                        <Grid item xs={12} className={classes.ENTERED}>
                          <FormControlLabel
                            value="ENTERED"
                            control={<Radio />}
                            label="در مرکز"
                          />
                        </Grid>

                        <Grid item xs={12} className={classes.WAITING}>
                          <FormControlLabel
                            value="WAITING"
                            control={<Radio />}
                            label={vehicle.type == "PARCEL" ? "در انتظار تخلیه" : "در انتظار بارگیری"}
                          />
                        </Grid>

                        <Grid item xs={12} className={classes.EXITED}>
                          <FormControlLabel
                            value="EXITED"
                            control={<Radio />}
                            label="خارج شد"
                          />
                        </Grid>
                      </RadioGroup>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>
            <Grid container className={classes.infoSection}>
              <Grid item xs={2} spacing={1} className={classes.infoBar}>
                <Icon path={mdiBarcode} size={1} className={classes.infoIcon} />
              </Grid>

              <Grid item xs={4} spacing={1} className={classes.infoBar}>
                <Typography variant="body1">
                  شناسه راننده: {vehicle.id}
                </Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.infoSection}>
              <Grid item xs={2} spacing={1} className={classes.infoBar}>
                <Icon path={mdiFileOutline} size={1} className={classes.infoIcon} />
              </Grid>

              <Grid item xs={4} spacing={1} className={classes.infoBar}>
                <Typography variant="body1">
                  {vehicle.description}
                </Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.infoSection}>
              <Grid item xs={2} spacing={1} className={classes.infoBar}>
                <Icon path={mdiPhone} size={1} className={classes.infoIcon} />
              </Grid>

              <Grid item xs={4} spacing={1} className={classes.infoBar}>
                <Typography variant="body1">
                  {vehicle.driverMobileNumber}
                </Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.infoSection}>
              <Grid item xs={2} spacing={1} className={classes.infoBar}>
                <Icon path={mdiBook} size={1} className={classes.infoIcon} />
              </Grid>

              <Grid item xs={4} spacing={1} className={classes.infoBar}>
                <Typography variant="body1">{vehicle.fleetName}</Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.infoSection}>
              <Grid item xs={2} spacing={1} className={classes.infoBar}>
                <Icon path={mdiParking} size={1} className={classes.infoIcon} />
              </Grid>

              <Grid item xs={4} spacing={1} className={classes.infoBar}>
                <Typography variant="body1">
                  پارکینگ {vehicle.parkingNumber}
                </Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.infoSection}>
              <Grid item xs={2} spacing={1} className={classes.infoBar}>
                <Icon
                  path={mdiPackageVariantClosed}
                  size={1}
                  className={classes.infoIcon}
                />
              </Grid>

              <Grid item xs={4} spacing={1} className={classes.infoBar}>
                <Typography variant="body1">
                  {vehicle.bundleOrdersCount} سفارش
                </Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.infoSection}>
              <Grid item xs={2} spacing={1} className={classes.infoBar}>
                تاریخ ورود
              </Grid>

              <Grid item xs={4} spacing={1} className={classes.infoBar}>
                <Typography variant="body1">
                  {jMoment(vehicle.created, 'YYYY/M/D')
                    .locale('fa')
                    .format('jYY/jMM/jDD')}
                </Typography>
              </Grid>
            </Grid>
            <Grid container className={classes.infoSection}>
              <Grid item xs={2} spacing={1} className={classes.infoBar}>
                آخرین تغییر
              </Grid>

              <Grid item xs={4} spacing={1} className={classes.infoBar}>
                <Typography variant="body1">
                  {jMoment(vehicle.updated, 'YYYY/M/D')
                    .locale('fa')
                    .format('jYY/jMM/jDD')}
                </Typography>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
    </React.Fragment >
  );
};
